<template>
  <div id='mus'>
    <Header :searchcategories="searchcategories" :searchlinks="searchlinks" :fburl="fburl" :instagramurl="instagramurl"></Header>
    <Navbar ref="navbar" :navitems="navitems"></Navbar>

    <scrollHeader ref="scrollHeader" v-bind:class="{'d-none':setScrollHeader}" :searchcategories="searchcategories" :fburl="fburl" :instagramurl="instagramurl" :navitems="navitems"></scrollHeader>

    <slot name="carousel"> </slot>

    <div id="body">
        <div class="container">
            <div class="row"> 
                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                    <div id="leftbody" class="p-0">
                        <slot name="body"> </slot>
                    </div>
                </div>
                <Rightbody class="col-lg-3 col-md-3 col-sm-12 col-12" :fburl="fburl" :instagramurl="instagramurl">
                    <template slot="sidebar">

                        <slot name="sidebar">
                            
                        </slot>
                    
                    </template>
                </Rightbody>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import "./css/mus.css";

import Header from "./layouts/header.vue";
import scrollHeader from "./layouts/onscroll-header.vue";

export default {
    name: 'mus',
    props:{
        // Header
        'searchcategories' : {
            type: Array
        },
        'fburl' : {
            type: String
        },
        'instagramurl' : {
            type: String
        },
        'searchlinks' : {
            type: Array
        },
        // Navbar
        'navitems' : {
            type: Array
        },
    },
    components: {
        Header,
        scrollHeader,
    },
    data(){
    return{
        setScrollHeader:true,
    }
  },
  methods:{
     handleScroll: function () {
            let navbarOffset=this.$refs.navbar.$el.offsetTop;
              window.pageYOffset > navbarOffset? this.setScrollHeader=false: this.setScrollHeader=true;
            }
  },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script> 

<style>
      
      #carousel1 li{
          position: relative;
          -ms-flex: 0 1 auto;
          -webkit-box-flex: 0;
          flex: 0 1 auto;
          width: 10px;
          height: 10px;
          margin-right: 3px;
          margin-left: 3px;
          text-indent: -999px;
          cursor: pointer;
          border-radius: 50% !important;
      }
      #carousel_right .carousel-control-prev{
          height: 50%;
          font-size: 40px;
      }
      #carousel_right .carousel-control-next{
          height: 50%;
          font-size: 40px;
      }
      #carousel_right .carousel-caption{
        left: 5%;
        right: 5%;
      }
      #category__BV_toggle_{ 
        color: dimgray;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        background: #f2e5d2;
        border: none;
    }
    
        
    #carousel_right .carousel-item{
        height: 340px !important;
        background: rgb(205, 181, 179);
    }
    #carousel_right .carousel-item img{
        width: 100px;
        max-height: 200px;
        margin-bottom: 10px;
    }
    #carousel_right .carousel-item h5 a{
      color:white;
      text-decoration: none;
    }

    #carousel_right .carousel-control-next-icon{
      background-image: url("../../assets/images/right.png")  !important;
      width: 131px !important;
      height: 56px !important;
      margin-right: 10px;
    }
    #carousel_right .carousel-control-prev-icon{
      background-image: url("../../assets/images/left.png")  !important;
      width: 131px !important;
      height: 56px !important;
      margin-right: 10px;
    }

    #baseCarousel  .carousel-item{
        height: 300px !important;
    }
    #baseCarousel .carousel-item img{
        width: 100px;
        max-height: 200px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/mus/mus.vue